export default __webpack_public_path__ + "static/media/GothamMedium.e662f21a.otf";